const initialState = {
    loading: false,
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'JIRA_STATISTICS_REQUEST') {
        return {
            filters: state.filters,
            loading: true,
            statisticsCategory: state.statisticsCategory,
            statisticsViewType: 'chart',
        };
    }
    if (action.type === 'JIRA_STATISTICS_SUCCESS') {
        if (action.actionParams && action.actionParams.filters) {
            return {
                ...state,
                filters: { totalIssues: action.payload.total },
            };
        }
        return {
            ...state,
            ...action.payload.collection.reduce(
                (acc, el) => ({
                    changedParts: [...(acc.changedParts || []), el.replacedParts].flat(),
                    clients: [...(acc.clients || []), el.clientName],
                    components: [...(acc.components || []), el.components].flat(),
                    failureTypes: [...(acc.failureTypes || []), el.issueType].flat(),
                    issues: action.payload.collection,
                    labels: [...(acc.labels || []), el.labels].flat(),
                    locations: [...(acc.locations || []), el.apmSerial].flat(),
                    partners: [...(acc.partners || []), el.partnerName],
                    partsReplaced: [
                        ...(acc.partsReplaced || []),
                        el.partsReplaced ? 'Yes' : 'No',
                    ].flat(),
                    priced: [...(acc.priced || []), el.priced ? 'Yes' : 'No'],
                    productCategories: [
                        ...(acc.productCategories || []),
                        el.productCategory ? el.productCategory : 'No Value',
                    ].flat(),
                    totalIssues: action.payload.collection.length,
                    visit: [...(acc.visit || []), el.visit ? 'Yes' : 'No'],
                }),
                {}
            ),
            loading: false,
        };
    }
    if (action.type === 'JIRA_STATISTIC_CATEGORY') {
        return { ...state, statisticsCategory: action.payload };
    }
    if (action.type === 'JIRA_STATISTIC_VIEWTYPE') {
        return { ...state, statisticsViewType: action.payload };
    }

    return state;
}

export default reducer;
